/**
 * Handles signing in & out of Charter Index via Gangplank.
 */
export class GangplankClient {
	readonly #gangplankUrl: string;
	#activeRefresh: Promise<boolean> | null = null;

	constructor(gangplankUrl: string) {
		this.#gangplankUrl = gangplankUrl;
	}

	/**
	 * Sign in to Charter Index.
	 */
	signIn(): void {
		const url = new URL(this.#gangplankUrl);
		url.searchParams.set("callback", window.location.href);
		window.location.href = url.href;
	}

	/**
	 * Sign out of Charter Index.
	 */
	signOut(): void {
		const url = new URL("/logout", this.#gangplankUrl);
		window.location.href = url.href;
	}

	async #refresh(): Promise<boolean> {
		const url = new URL("/refresh", this.#gangplankUrl);
		const response = await fetch(url, {
			mode: "cors",
			credentials: "include",
		});
		const body = await response.json();
		return body.ok;
	}

	async refresh(): Promise<boolean> {
		// Ensure only one request to refresh runs concurrently to avoid race
		// condition when multiple queries get 401'ed at the same time.
		return this.#activeRefresh ??= this.#refresh().finally(() => this.#activeRefresh = null);
	}
}
